import React from 'react'
import "../css/main1.css"

function Section1() {
  return (
    <div className='section01' id ="intro">
       <div className='innerContainer'>
        <small>FullStack Developer</small>
        <div className='sec01TextWrap'>
          <div className='lineWrap'><h1>사람과 시스템, 현재와 미래를 잇는</h1></div>
          <div className='lineWrap'><h1>풀스택 개발자 <span>김민주</span>입니다.</h1></div>
        </div>
       </div>
    </div>
  )
}

export default Section1